<template>
  <div>
    <patternlib-modal
      :show="isVisible"
      @lhClose="hide()"
      @lhConfirm="hide()"
      :confirm-label="t('response.confirm')"
      :cancel-label="t('response.cancel')"
      @lhCancel="hide()"
      :cancel-button-disabled="false"
      :hide-confirm="false"
      hide-cancel
      :modal-title="t('response.title')"
    >
      <div slot="modal-content">
        <div v-if="!isErrorState">
          <patternlib-icon
            icon-name="checkmark"
            size="64px"
            style="justify-self: center"
          ></patternlib-icon>
          <div>
            {{ $t('response.success.message') }}
          </div>
          <div style="font-weight: bold" :class="$gStyle('mt-3')">
            {{ $t('response.success.selectedProduct') }}:
          </div>
          <div
            v-for="order in orders"
            style="display: flex; flex-direction: row; align-items: center"
          >
            <span style="flex-grow: 1"
              >{{
                `${order.qty}x ${order.articleName} - ${order.articleNumber}`
              }}
            </span>
          </div>
        </div>
        <div v-else>
          <patternlib-icon
            icon-name="triangle-with-exclamation-mark"
            size="64px"
          ></patternlib-icon>
          <div>
            {{ $t('response.error.message') }}
          </div>
        </div>
      </div></patternlib-modal
    >
  </div>
</template>

<script setup lang="ts">
  import { storeToRefs } from 'pinia';
  import { ref } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { useOrderStore } from '../../stores/order';

  const isVisible = ref(false);
  const isErrorState = ref(false);

  const { t } = useI18n();
  const orderStore = useOrderStore();
  const { orders } = storeToRefs(orderStore);
  const { clearCompleteOrder } = orderStore;

  const show = () => {
    isVisible.value = true;
  };

  const showError = () => {
    isErrorState.value = true;
    show();
  };
  const hide = () => {
    isVisible.value = false;

    if (!isErrorState) [clearCompleteOrder()];
  };

  defineExpose({ show, hide, showError });
</script>

<style scoped></style>
